import React, { useState } from 'react';
import LayoutUsuario from '@/components/navegacao/LayoutUsuario';
import Titulo from '@/components/tipografia/Titulo';
import Descricao from '@/components/tipografia/Descricao';
import VBox from '@/components/layout/VBox';
import HBox from '@/components/layout/HBox';
import Tabs from '@/components/layout/Tabs';
import { mdiFormatListBulleted, mdiDatabase, mdiShield, mdiShieldLock, mdiTagMultiple, mdiTransferUp, mdiTransferDown } from '@mdi/js';
import { PoliciesTab } from './PoliciesTab';
import { InboundPoliciesTab } from './InboundPoliciesTab';
import { FeedsTab } from './FeedsTab';
import { EventsTab } from './EventsTab';
import { CategoriesTab } from './CategoriesTab';

export default function FirewallPage() {
    const [tab, setTab] = useState('politicas');

    const tabs = [
        { id: 'politicas', label: 'Saída', icon: mdiTransferUp },
        { id: 'entrada', label: 'Entrada', icon: mdiTransferDown },
        { id: 'feeds', label: 'Feeds de IP', icon: mdiDatabase },
        { id: 'categorias', label: 'Categorias', icon: mdiTagMultiple },
        { id: 'logs', label: 'Logs de Eventos', icon: mdiFormatListBulleted },
    ];

    return (
        <LayoutUsuario>
            <VBox style={{ padding: '24px', gap: '16px', height: '100%', overflow: 'hidden' }}>
                <HBox>
                    <VBox style={{ flex: 1 }}>
                        <Titulo>Firewall</Titulo>
                        <Descricao>Gerencie políticas de saída e de entrada, feeds, categorias e eventos de segurança</Descricao>
                    </VBox>
                </HBox>

                <Tabs tabs={tabs} selectedTab={tab} onTabChange={setTab} size='lg' />

                {tab === 'politicas' && <PoliciesTab />}
                {tab === 'entrada' && <InboundPoliciesTab />}
                {tab === 'feeds' && <FeedsTab />}
                {tab === 'categorias' && <CategoriesTab />}
                {tab === 'logs' && <EventsTab />}
            </VBox>
        </LayoutUsuario>
    );
}
